export function activeTheme(state) {
  return state.activeTheme
}

export function activeTab(state) {
  return state.activeTab
}

export function activeTabMechanism(state) {
  return state.activeTabMechanism
}

export function activeTabPlate(state) {
  return state.activeTabPlate
}

export function preset(state) {
  return state.preset
}

export function custom(state) {
  return state.custom
}

export function cart(state) {
  return state.cart
}

export function getTotalPrice(state) {
  return state.getTotalPrice
}
